import React, { useState } from "react";
import { SimpleAutoComplete } from "./SimpleAutoComplete";
import AutoCompleteUIDTO, { EMPTY_AUTOCOMPLETE } from "../dto/AutoCompleteUIDTO";
import { makeStyles } from "@mui/styles";
import { FilterDialogButton } from "./FilterDialog";
import useWindowSize from "../hooks/useWindowSize";
import { FormGroup } from "@material-ui/core";
import { SwitchCustom } from "../utils/SwitchCustom";
import { AssignationStatusFilters } from "../utils/enums/filters/AssignationStatusFilters";
import { SelectComponent } from "./SelectComponent";
import { CURRENT_YEAR_MAX_DATE, DatePickerComponent, DatePickerWrapper, MIN_DATE } from "./AppToolbar";
import { PositionStatusFilters } from "../utils/enums/filters/PositionStatusFilters";
import { Button } from "@mui/material";
import { ColorUtils } from "../utils/ColorUtils";

const useStyles = makeStyles(() => ({
  desktopFilters: {
    "&>div": {
      margin: "0 !important",
    },
    width: "100%",
    padding: "5px",
    display: "flex",
    flexDirection: "row",
    columnGap: ".8rem",
    "&> div:first-child": {
      minWidth: "150px",
      marginLeft: "0",
    },
    "&> div:nth-child(2)": {
      minWidth: "150px",
    },
  },
  mobileFilters: {
    "&> div:first-child": {
      minWidth: "150px",
      width: "100%",
      marginLeft: "0",
    },
    padding: "5px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
  },
  addButton: {
    backgroundColor: `${ColorUtils.ENSOLVERS_ORANGE_REBRANDING} !important`,
    marginLeft: "auto !important", //To send the button to the right end
  },
}),
{ index: 1 },
);


interface Props {
  projectsNames: AutoCompleteUIDTO[];
  selectedProject?: AutoCompleteUIDTO;
  onChangeProject: (value: AutoCompleteUIDTO) => void;
  positionStatus?: string;
  onChangePositionStatus?: (value: string) => void;
  assignationStatus?: string;
  onChangeAssignationStatus?: (value: string) => void;
  isOpen?: boolean;
  onChangeOpen?: (open: boolean) => void;
  assigned?: boolean;
  onAssignedChange?: () => void;
  selectedDate?: Date;
  onChangeMonth?: (value: Date | null) => void;
  onChangeYear?: (value: Date | null) => void;
  canCreate?: boolean;
  onClickCreate?: () => void;
}

function ProjectFilters({
  projectsNames,
  selectedProject,
  onChangeProject,
  positionStatus,
  onChangePositionStatus,
  assignationStatus,
  onChangeAssignationStatus,
  isOpen = false,
  onChangeOpen,
  assigned,
  onAssignedChange,
  selectedDate,
  onChangeMonth,
  onChangeYear,
  canCreate = false,
  onClickCreate,
}: Props) {
  const classes = useStyles();
  const { isMobileWidth } = useWindowSize();

  const renderProjectNameAutoComplete = (
    <SimpleAutoComplete
      label="Project Name"
      items={projectsNames}
      value={selectedProject ? selectedProject : EMPTY_AUTOCOMPLETE}
      onChange={onChangeProject}
    />
  );

  const renderDialogFilters = (
    <>
      {!!positionStatus && !!onChangePositionStatus && (
        <SelectComponent
          label={"Position Status"}
          value={positionStatus}
          setValue={onChangePositionStatus}
          options={Object.values(PositionStatusFilters)}
          size="small"
        />
      )}
      {!!assignationStatus && !!onChangeAssignationStatus && (
        <SelectComponent
          label={"Assignation Status"}
          value={assignationStatus}
          setValue={onChangeAssignationStatus}
          options={Object.values(AssignationStatusFilters)}
          size="small"
        />
      )}
      {!!assigned && !!onAssignedChange && (
        <FormGroup>
          <SwitchCustom checked={assigned} onChange={onAssignedChange!} size="medium" color="primary" label="Assigned to me" />
        </FormGroup>
      )}
      {!!selectedDate && (
        <DatePickerWrapper
          className="date-picker"
          style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", columnGap: "10px" }}
        >
          {!!onChangeMonth && (
            <DatePickerComponent views="month" label="Month" value={selectedDate!} inputFormat="MMMM" onChange={onChangeMonth!} />
          )}
          {!!onChangeYear && (
            <DatePickerComponent
              views="year"
              label="Year"
              value={selectedDate!}
              inputFormat="yyyy"
              minDate={MIN_DATE}
              maxDate={CURRENT_YEAR_MAX_DATE}
              onChange={onChangeYear!}
            />
          )}
        </DatePickerWrapper>
      )}
      {canCreate && (
        <Button onClick={onClickCreate} variant="contained" className={classes.addButton}>
          Create position
        </Button>
      )}
    </>
  );

  const mobileFilters = (
    <div className={classes.mobileFilters}>
      {renderProjectNameAutoComplete}
      <FilterDialogButton isOpen={isOpen} setIsOpen={onChangeOpen!!} />
    </div>
  );

  const desktopFilters = (
    <div className={classes.desktopFilters}>
      {renderProjectNameAutoComplete}
      {renderDialogFilters}
    </div>
  );
  return isMobileWidth() ? mobileFilters : desktopFilters;
}

export default ProjectFilters;
